export const CalendarDarkIcon: React.FC = () => {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.80005 9H19.8M3.80005 9V17.8C3.80005 18.92 3.80005 19.48 4.01805 19.908C4.20979 20.2843 4.51574 20.5903 4.89205 20.782C5.31905 21 5.87905 21 6.99705 21H16.603C17.721 21 18.28 21 18.707 20.782C19.084 20.59 19.39 20.284 19.582 19.908C19.8 19.48 19.8 18.922 19.8 17.804V9M3.80005 9V8.2C3.80005 7.08 3.80005 6.52 4.01805 6.092C4.21005 5.715 4.51505 5.41 4.89205 5.218C5.32005 5 5.88005 5 7.00005 5H7.80005M19.8 9V8.197C19.8 7.079 19.8 6.519 19.582 6.092C19.39 5.71554 19.0837 5.40957 18.707 5.218C18.28 5 17.72 5 16.6 5H15.8M7.80005 5H15.8M7.80005 5V3M15.8 5V3"
				stroke="#212B36"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
			<rect fill="#212B36" height="16" rx="3" width="16" x="3.80005" y="5" />
			<rect fill="white" height="2" width="17.55" x="3" y="8" />
		</svg>
	);
};
